export enum ProductTypeEnums {
  HOTEL = "hotel",
  FLIGHT = "flight",
  EXPERIENCE = "experience",
  CARRENTAL = "car-rental",
  CARRENTAL2 = "carrental",
  EVENT = "event",
  CAR = "car",
  TOUR = "tour-package",
}

export enum RequestListProductTypeEnums {
  HOTEL = "hotel",
  FLIGHT = "flight",
  EXPERIENCE = "experience",
  EVENT = "event",
  CAR = "car",
}

export enum ProductTypeTapEnums {
  TOTAL = "all",
  HOTEL = "hotel",
  FLIGHT = "flight",
  EXPERIENCE = "experience",
  CARRENTAL = "car-rental",
}

export enum BookingStepEnums {
  INCOMING = "incoming",
  COMPLETE = "complete",
  CANCELED = "canceled",
}

export enum BookingStatusEnums {
  WAITTOPAY = "waittopay", // NOTE - "รอชำระเงิน" >>> "Awaiting Payment"
  UNPAID = "unpaid", // NOTE - "ชำระเงินไม่สำเร็จ" >>> "Unsuccessful Payment"
  WAITTOBOOK = "waittobook", // NOTE - "กำลังดำเนินการ" >>> "In Progress"
  BOOKED = "booked", // NOTE - "ยืนยันการจองแล้ว" >>> "Booking Confirmed"
  COMPLETE = "complete", // NOTE - "เสร็จสมบูรณ์" >>> "Completed"
  CANCELED = "canceled", // NOTE - "ยกเลิกการจองแล้ว" >>> "Booking Cancelled"
  REFUNDED = "refunded", // NOTE - "คืนเงินสำเร็จ" >>> "Refund Success"
  PROCESS = "on process", // NOTE - "ดำเนินการคืนเงิน" >>> "Refund in Process"
}

export enum BookingStatusStyleEnums {
  PENDING = "text-status-orange-1 bg-status-orange-3",
  FAIL = "text-status-red-1 bg-status-red-3",
  SUCCESS = "text-status-green-1 bg-secondary-green-lighter",
  CANCELED = "text-darkGrey bg-lighterGrey",
}

export enum FlightTypeEnums {
  RETURN = "return",
  DEPARTURE = "departure",
}

export enum FlightTypeOfTripEnums {
  ONEWAYTRIP = "o",
  ROUNDTRIP = "r",
  MULTIPLETRIP = "m", // TODO - ยังไม่รู้ value
}

export enum PassengerTypeEnums {
  ADULT = "adult",
  CHILD = "child",
  INFANT = "infant",
}

export enum PaymentStatusEnums {
  UNPAID = "unpaid",
  PAID = "paid",
  PENDING = "pending",
  PAYLATER = "paylater",
}

export enum PaymentChanelEnums {
  CREDITCARD = "creditcard",
  INSTALLMENT = "installment",
  BUYNOWPAYLATER = "buynowpaylater",
}

export enum BeforeStepSubmitTypeEnums {
  CANCELED = "canceled",
  EDITCONTACT = "edit-contact",
}

export enum RequestBedTypeEnums {
  KINGSIZE = "king size",
  TWINBED = "twin bed",
}
